import React, { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiRegister, apiMe } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dg_token");
    if (!token) {
      setLoading(false);
      return;
    }
    apiMe()
      .then(setUser)
      .catch(() => localStorage.removeItem("dg_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await apiLogin({ email, password });
    localStorage.setItem("dg_token", token);
    setUser(user);
    return user;
  };

  const register = async (data) => {
    const { token, user } = await apiRegister(data);
    localStorage.setItem("dg_token", token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("dg_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
